import { WebsocketMessage } from 'app/types';
import camelcaseKeys from 'camelcase-keys';
import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';

const getQueryKey = (message: WebsocketMessage): (string | number)[] => {
  if (message.model?.quarter) {
    return [
      message.type,
      message.model?.inspector_id || message.model?.agency_company_id || '',
      message.model?.quarter || '',
    ];
  }

  return [
    message.type,
    message.model?.inspector_id || message.model?.agency_company_id || '',
    message.model?.date_from || '',
    message.model?.date_to || '',
  ];
};

export interface MetricsDataProps {
  message: WebsocketMessage;
}

export default function MetricsData(props: MetricsDataProps) {
  const { message } = props;

  const queryClient = useQueryClient();

  useEffect(() => {
    if (!message.model || message?.model?.error) {
    } else {
      const queryKey = getQueryKey(message);

      queryClient.setQueryData(queryKey, {
        isLoading: false,
        results: camelcaseKeys(message.model.results),
      });
    }
  }, [message.uuid]);

  return null;
}
